import { Device } from "@twilio/voice-sdk";
import Store from "@/App/store/index";
import { HttpClient } from "@/App/services/HttpClient";
import { CASE_ENDPOINTS } from "@/Case/config";
import { casePlaceholderRegex } from "../store/casePlaceholderRegex";

export default {
  async prepareClient(): Promise<Device> {
    const twiageCase = Store.getters["Case/twiageCase"];

    if (!casePlaceholderRegex.test(twiageCase?.id)) {
      const response = await HttpClient.get(CASE_ENDPOINTS.VOIP_TOKEN(twiageCase.id));
      const { token } = response;
      const device = new Device(token, {
        logLevel: 1,
      });
      await device.register();
      return Promise.resolve(device);
    }
    return Promise.reject(new Error("Case is not open"));
  },
};
